/**
 * Leitor de planilha do Master, sem dependencia nova.
 *
 * O Master nao tem xlsx, papaparse nem jszip (o V2 tem, mas o parser de la
 * depende de jszip para .xlsx). Aqui aceitamos CSV e TXT, que e o que a equipe
 * exporta do Excel — e resolvemos o problema que a base de codigo documenta
 * como causa historica numero um de erro de importacao no Brasil:
 *
 *   "o CSV salvo pelo Excel pt-BR sai em ANSI"
 *   (MarQ.Backoffice.V2 .../modalImportPositions/importStep.tsx:41-43)
 *
 * Por isso a leitura tenta UTF-8 primeiro e cai para Windows-1252 quando
 * aparece o caractere de substituicao. Sem isso "João" chega como "Jo?o" e o
 * nome nunca casa.
 */

const REPLACEMENT = '�';

/** Excel pt-BR usa ';'. Detecta pelo cabecalho em vez de assumir. */
const detectDelimiter = (firstLine) => {
  const counts = [
    { char: ';', total: (firstLine.match(/;/g) || []).length },
    { char: ',', total: (firstLine.match(/,/g) || []).length },
    { char: '\t', total: (firstLine.match(/\t/g) || []).length },
  ];
  counts.sort((a, b) => b.total - a.total);
  return counts[0].total > 0 ? counts[0].char : ';';
};

const stripBom = (text) => text.replace(/^﻿/, '');

const decode = (buffer) => {
  const utf8 = new TextDecoder('utf-8').decode(buffer);
  if (utf8.indexOf(REPLACEMENT) === -1) return utf8;

  try {
    return new TextDecoder('windows-1252').decode(buffer);
  } catch (e) {
    // Navegador sem o rotulo windows-1252: fica o UTF-8, com acento torto,
    // mas legivel — melhor que falhar a importacao inteira.
    return utf8;
  }
};

/**
 * Devolve as celulas nao vazias da PRIMEIRA coluna, ja sem cabecalho.
 *
 * Primeira coluna de proposito: a planilha que o time monta tem uma coluna de
 * identificador e, as vezes, colunas soltas de anotacao. Ler tudo transformaria
 * um comentario em termo de busca.
 */
export const readCompanyTermsFromCsv = (file) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();

    reader.onerror = () => reject(new Error('Não foi possível ler o arquivo.'));

    reader.onload = () => {
      try {
        const text = stripBom(decode(reader.result));
        const lines = text.split(/\r\n|\r|\n/).filter((line) => line.trim());

        if (!lines.length) {
          resolve([]);
          return;
        }

        const delimiter = detectDelimiter(lines[0]);
        const firstCell = (line) =>
          (line.split(delimiter)[0] || '').trim().replace(/^"|"$/g, '');

        const head = firstCell(lines[0]).toLowerCase();
        // Cabecalho e opcional: so pula a primeira linha se ela parecer rotulo.
        const isHeader =
          ['id', 'cnpj', 'empresa', 'nome', 'codigo', 'código'].indexOf(head) !== -1;

        const terms = lines
          .slice(isHeader ? 1 : 0)
          .map(firstCell)
          .filter((value) => value.length > 0);

        resolve(terms);
      } catch (error) {
        reject(error);
      }
    };

    reader.readAsArrayBuffer(file);
  });

/**
 * Termos colados na busca. Virgula, ponto-e-virgula e quebra de linha, porque
 * colar de uma planilha traz quebra de linha e o placeholder do Figma promete
 * virgula.
 */
export const splitCompanyTerms = (raw) =>
  (raw || '')
    .split(/[,;\n\r]+/)
    .map((value) => value.trim())
    .filter((value) => value.length > 0);

/**
 * Planilha modelo da importacao: so o cabecalho `cnpj`, que o leitor acima ja
 * pula. Sem linha de exemplo de proposito — esquecida na planilha, ela viraria
 * termo de busca. UTF-8 com BOM para o Excel pt-BR abrir com acento certo; o
 * leitor aceita os dois.
 */
export const COMPANY_TEMPLATE_NAME = 'modelo-empresas.csv';
export const COMPANY_TEMPLATE_CONTENT = '\uFEFFcnpj\r\n';

export const downloadCompanyTemplate = () => {
  const blob = new Blob([COMPANY_TEMPLATE_CONTENT], { type: 'text/csv;charset=utf-8' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = COMPANY_TEMPLATE_NAME;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
};



// WEBPACK FOOTER //
// ./src/vue/pages/restricted/broadcast/broadcastCsv.js